import { create } from 'zustand'

import { IRootStore, IRootStoreProps } from '../types/store'

const INITIAL_STORE: IRootStoreProps = {
  marketplaceList: [],
}

export const useRootStore = create<IRootStore>(set => ({
  ...INITIAL_STORE,

  setMarketplaceList: marketplaceList => set({ marketplaceList }),
  setProfile: profile => set({ profile }),
  setPage: page => set({ page }),
  setMessage: (text, type = 'info') =>
    set({ message: text ? { text, type } : undefined }),
  clear: () => {
    set(INITIAL_STORE)
  },
}))
